import { SVGProps } from "react";

const IconTagPrice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.9543 11.1174L2.02754 10.7417L1.86137 11.1517L2.05294 11.5504L2.9543 11.1174ZM6.03526 3.51605L6.32113 2.55778L5.10849 3.14041L6.03526 3.51605ZM13.8949 5.86077L14.7963 5.4277L14.6047 5.02896L14.1808 4.9025L13.8949 5.86077ZM18.4347 15.3095L18.8678 16.2109L19.7692 15.7778L19.3361 14.8764L18.4347 15.3095ZM7.49409 20.5661L6.59273 20.9992L7.0258 21.9005L7.92716 21.4675L7.49409 20.5661ZM3.88107 11.493L6.96203 3.89169L5.10849 3.14041L2.02754 10.7417L3.88107 11.493ZM5.74939 4.47432L13.6091 6.81904L14.1808 4.9025L6.32113 2.55778L5.74939 4.47432ZM12.9936 6.29384L17.5334 15.7426L19.3361 14.8764L14.7963 5.4277L12.9936 6.29384ZM18.0017 14.4081L7.06102 19.6647L7.92716 21.4675L18.8678 16.2109L18.0017 14.4081ZM8.39545 20.133L3.85566 10.6843L2.05294 11.5504L6.59273 20.9992L8.39545 20.133Z"
      fill="#DF0024"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.50243 10.7321C10.3264 10.3362 10.6734 9.34736 10.2775 8.52341C9.88164 7.69945 8.89277 7.35243 8.06881 7.74831C7.24485 8.14419 6.89783 9.13307 7.29371 9.95702C7.6896 10.781 8.67847 11.128 9.50243 10.7321Z"
      stroke="#DF0024"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.86463 7.72197C7.86463 7.72197 6.66667 3.08335 12.1595 2.10028"
      stroke="#DF0024"
      strokeWidth="2"
      strokeLinecap="square"
    />
  </svg>
);

export default IconTagPrice;